type Confirmation = (complete: (allow: boolean) => void) => void;
const handlers = new Map<string, Confirmation>();
export const roleNavigationMessage = "lifecycle-role-unsaved-changes";

export function registerRoleNavigation(handler: Confirmation) {
  handlers.set(roleNavigationMessage, handler);
  return () => {
    handlers.delete(roleNavigationMessage);
  };
}
export function confirmNavigation(
  message: string,
  complete: (allow: boolean) => void,
) {
  const handler = handlers.get(message);
  if (handler) handler(complete);
  else complete(window.confirm(message));
}
